import Equalizer from 'react-equalizer';
import ImageResponsive from '../../../contentful/ImageResponsive';
import React from 'react';
import {NavLink as Link} from 'react-router-dom';

class ColorList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      colors: null,
      working: false,
      hideArchived: true
    };
  }

  handleArchive(colorObj, modelId) {
    if (colorObj && modelId) {
      this.props.onColorChange(colorObj, modelId);
    }
  }

  toggleShowArchived() {
    this.setState({
      hideArchived: !this.state.hideArchived
    });
  }

  render() {
    const colors = this.props.colors;
    const modelId = this.props.modelId;

    return (
      <div>
        <div className="pull-right">
          <Link
            to={`/farge/new/${modelId}`}
            className={`${this.props.modelModified ? 'disabled ' : ''}btn btn-default`}
          >
            <i className="fa fa-plus" aria-hidden="true"></i> Legg til farge
          </Link>
          &nbsp;
          <button onClick={(e) => {
            e.preventDefault();
            this.toggleShowArchived();
          }} className="btn btn-info" disabled={this.state.working}>
            {this.state.hideArchived ? 'Vis arkiverte' : 'Skjul arkiverte'}
          </button>
        </div>
        <div className="row clearboth">
          <Equalizer byRow={false}>
            {colors.map((color) => {
              if (this.state.hideArchived && color.archived) {
                return;
              }

              let statusClass = 'warning';
              let text = 'Kladd';

              if (color.published) {
                if (color.updated) {
                  statusClass = 'info';
                  text = 'Oppdatert';
                } else {
                  statusClass = 'success';
                  text = 'Publisert';
                }
              } else if (color.archived) {
                statusClass = 'danger';
                text = 'Arkivert';
              }

              const colorRef = (color.reference ? color.reference : 'transparent');

              const colorRefStyles = {
                width: '100%',
                height: '100%',
                backgroundColor: colorRef,
                backgroundImage: 'linear-gradient(135deg,rgba(255, 255, 255, 0),rgba(255, 255, 255,.75))'
              };

              return (
                <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3" key={color.id} title={text}>
                  <div className={`panel panel-${statusClass}`}>
                    <div className="panel-heading">
                      <h3 className="panel-title">{color.name}</h3>
                    </div>
                    <div className="panel-body">
                      <div className="row">
                        <Equalizer>
                          <div className="col-xs-6">
                            {color.mainImage &&
                              <ImageResponsive
                                src={color.mainImage.url}
                                width={color.mainImage.details.image.width}
                                height={color.mainImage.details.image.height}
                                aspect={1}
                              />
                            }
                          </div>

                          <div className="col-xs-6">
                            {color.reference &&
                              <div className="color-reference-square" style={colorRefStyles}></div>
                            }
                          </div>
                        </Equalizer>
                        <div className="clearfix"></div>

                        <div className="col-xs-6 mf-margin-top-10">
                          <strong>Ekstern ID</strong>
                        </div>
                        <div className="col-xs-6 mf-margin-top-10">
                          {color.externalId}
                        </div>
                        <div className="clearfix"></div>

                        <div className="col-xs-6">
                          <strong>Fargekode</strong>
                        </div>
                        <div className="col-xs-6">
                          {color.reference &&
                            colorRef
                          }
                        </div>
                        <div className="clearfix"></div>

                        <div className="col-xs-6">
                          <strong>Fargetype</strong>
                        </div>
                        <div className="col-xs-6">
                          {color.type}
                        </div>
                        <div className="clearfix"></div>

                        <div className="col-xs-6">
                          <strong>Fargen passer for</strong>
                        </div>
                        <div className="col-xs-6">
                          {color.equipmentLevelWhitelist.length && (
                            `Utstyrsnivå ${color.equipmentLevelWhitelist.map((level) => level.name).join(', ')}`
                          )}
                          {!color.equipmentLevelWhitelist.length && (
                            'Alle utstyrsnivå'
                          )}
                        </div>
                        <div className="clearfix"></div>

                      </div>
                    </div>
                    <div className="panel-footer">
                      <Link
                        to={`/farge/${color.id}/${modelId}`}
                        disabled={(this.props.working)}
                        className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}
                      >
                        <i className="fa fa-pencil" aria-hidden="true"></i> Endre
                      </Link>
                      &nbsp;
                      <button
                        type="button"
                        className="btn btn-default"
                        disabled={(color.archived || this.props.working)}
                        onClick={(e) => {
                          e.preventDefault();
                          this.handleArchive(color, modelId);
                        }}
                      >
                        <i className="fa fa-times" aria-hidden="true"></i> Fjern / arkiver
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </Equalizer>
        </div>
      </div>
    );
  }
}

export default ColorList;
